import { render, staticRenderFns } from "./DisclaimerCondizioni.vue?vue&type=template&id=53632fa8&scoped=true"
import script from "./DisclaimerCondizioni.vue?vue&type=script&lang=js"
export * from "./DisclaimerCondizioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53632fa8",
  null
  
)

export default component.exports